import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LecturerSidebar from '../components/LecturerSidebar';
import QRDisplay from '../components/QRDisplay';
import { useQRSession } from '../contexts/QRSessionContext';

const QRDisplayPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { startQRGeneration, isActive } = useQRSession();
  const session = location.state?.session;
  const qrStarted = location.state?.qrStarted;

  const handleNewSession = () => {
    navigate('/qr');
  };

  useEffect(() => {
    // If we have a session but QR isn't started, start it
    if (session && !qrStarted && !isActive) {
      console.log('Starting QR generation for existing session:', session.session_id);
      startQRGeneration(session.session_id).catch(err => {
        console.error('Failed to start QR generation:', err);
      });
    }
  }, [session, qrStarted, isActive, startQRGeneration]);

  if (!session) {
    return (
      <div style={{ display: 'flex', minHeight: '100vh', background: '#F5F6FA' }}>
        <LecturerSidebar />
        <div style={{ marginLeft: 290, padding: '32px 40px', flex: 1 }}>
          <div style={{ 
            textAlign: 'center', 
            marginTop: '100px',
            backgroundColor: '#fff',
            padding: '40px',
            borderRadius: '10px',
            border: '1px solid #ddd'
          }}>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>📱</div>
            <h2 style={{ color: '#252C58', marginBottom: '10px' }}>No Session Found</h2>
            <p style={{ color: '#666', marginBottom: '30px' }}>
              Please create a new QR session to start generating QR codes for attendance.
            </p>
            <button
              onClick={handleNewSession}
              style={{
                backgroundColor: '#F04915',
                color: 'white',
                padding: '12px 30px',
                border: 'none',
                borderRadius: '5px',
                fontSize: '16px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Create New Session
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#F5F6FA' }}>
      <LecturerSidebar />
      <div style={{ marginLeft: 290, padding: '32px 40px', flex: 1 }}>
        <QRDisplay session={session} onNewSession={handleNewSession} />
      </div>
    </div>
  );
};

export default QRDisplayPage;
